export default __webpack_public_path__ + "static/media/aiFaceActive.svg.2e61e874.svg";